import { personalizeMultiAssistant } from "../api/personalizeAssistant";
import { getUserRole } from "./service";

export async function handleUseAgent(assistantIds, navigate, setLoading) {
  const role = getUserRole();
  if (!assistantIds || !Array.isArray(assistantIds) || assistantIds.length === 0) {
    console.error("No valid assistant IDs provided");
    return;
  }

  try {
    setLoading(true);
    const results = await Promise.allSettled(
      assistantIds.map(async (assistantId) => {
        const response = await personalizeMultiAssistant(assistantId);
        return { assistantId, response };
      })
    );
    const successfulPersonalizations = results
      .filter((result) => result.status === "fulfilled" && result.value.response.success)
      .map((result) => ({
        originalId: result.value.assistantId,
        newAssistantId: result.value.response.newAssistantId || result.value.assistantId,
      }));

    const failedPersonalizations = results
      .filter((result) => result.status === "rejected" || !result.value.response.success)
      .map((result) => ({
        assistantId: result.value?.assistantId || "unknown",
        error: result.reason || result.value?.response.message || "Unknown error",
      }));

    if (failedPersonalizations.length > 0) {
      console.error("Some personalizations failed:", failedPersonalizations);
    }

    if (successfulPersonalizations.length > 0) {
      const state = {
        personalizedAssistantIds: successfulPersonalizations,
        isPersonalizing: true,
      };

      if (role === "admin") {
        navigate("/allAssistantsList", { state, replace: true });
      } else if (role === "superadmin") {
        navigate("/agentsList", { state, replace: true });
      }
    } else {
      console.error("No successful personalizations");
    }
  } catch (err) {
    console.error("Error during personalization:", err);
  } finally {
    setLoading(false);
  }
}